<template>
  <!-- 此处value仅用于触发updated事件 -->
  <div id="editor" :value="content"></div>
</template>
<script>
import E from 'wangeditor'
export default {
  name: 'Editor',
  props: {
    content: String
  },
  mounted: function () {
    this.editor = new E('#editor')
    this.editor.config.onchange = (html) => {
      this.$emit('update:content', html)
      console.log(this.editor.txt.text())
    }
    this.editor.create()
    this.editor.txt.html(this.content)
  }
  // updated: function () {
  //   this.editor.txt.html(this.content)
  // }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/Editor.vue